<template>
  <div class="ima-add-sign-to-shopping-cart-modal">

    <div class="ima-add-sign-to-shopping-cart-modal__form">
      <b-field label="Schild">
        <span class="field-label">{{this.sign.name}}</span>
      </b-field>

      <!--b-field label="Variante">
        <b-select v-model="variant" placeholder="Auswählen" required :loading="false" icon="web">
          <option v-for="option in options.variants" :value="option" :key="option.id">
            {{ option.name }} (ID: {{option.id}})
          </option>
        </b-select>
      </b-field-->

      <b-field label="Menge" is-horizontal>
        <b-input type="number" v-model="amount" min="1">
        </b-input>
      </b-field>
    </div>

    <div :style="{'text-align': 'right', 'margin-top' : '1rem'}">
      <button type="button" class="button is-success" :disabled="!isValidForm" @click="onConfirm">
        <b-icon icon="add_shopping_cart"></b-icon>
        <span>Hinzufügen</span>
      </button>
      <button type="button" class="button is-danger" @click="onCancel">Abbrechen</button>
    </div>

  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import inform from '@/services/inform'
import { closeModals } from '@/store/modules/modals'
import { addSign, unselectSign } from '@/store/modules/shopping-cart'
import routes from '@/mixins/routes'

import modals from '@/mixins/modals'

export default {
  name: 'ima-add-sign-to-shopping-cart-modal',
  data () {
    return {
      variant: null,
      amount: 1
    }
  },
  computed: {
    ...mapState(['shoppingCart', 'variants']),
    sign () {
      return this.shoppingCart.selectedSign
    },
    isValidForm () {
      return !!this.variant && this.amount > 0
    },
    options () {
      return {
        variants: this.sign.variants
      }
    }
  },
  mixins: [modals, routes],
  methods: {
    ...mapMutations([addSign, closeModals, unselectSign]),
    onConfirm () {
      const amount = parseInt(this.amount, 10)
      const { sign, variant } = this
      this.addSign({ sign, variant, amount })
      this.closeModals()
      inform(
        `${amount} x "${sign.name} - ${variant.name}" zum Warenkorb hinzugefügt`
      )
    },
    onCancel () {
      this.unselectSign()
      this.closeModals()
    }
  },
  created () {
    // Default selection
    this.variant = this.options.variants.find(({ isDefault }) => isDefault)
  }
}
</script>

<style scoped lang="scss">
.ima-add-sign-to-shopping-cart-modal {
  &__form {
    display: flex;

    .field {
      flex-grow: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/AddSignToShoppingCartModal.vue